import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faChevronDown, faLayerGroup, faTags, faUsersGear } from '@fortawesome/free-solid-svg-icons';
import { useClickOutside } from '../../hooks/useClickOutside';
import { useEscapeKey } from '../../hooks/useEscapeKey';
import '../FileMenu/FileMenu.css';
import { useI18n } from '../../i18n/I18nContext';

export interface AppMenuProps {
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  onManageProducts: () => void;
  onManageProductCategories: () => void;
  onManageUsers: () => void;
}

const AppMenu: React.FC<AppMenuProps> = ({
  open,
  onToggle,
  onClose,
  onManageProducts,
  onManageProductCategories,
  onManageUsers,
}) => {
  const { t } = useI18n();
  const menuRef = useRef<HTMLDivElement>(null);

  useClickOutside(menuRef, onClose, open);
  useEscapeKey(onClose, open);

  return (
    <div className="file-menu" ref={menuRef}>
      <button
        type="button"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(event) => {
          event.stopPropagation();
          onToggle();
        }}
      >
        <FontAwesomeIcon icon={faLayerGroup} /> {t('menus.app')} <FontAwesomeIcon icon={faChevronDown} />
      </button>
      {open && (
        <div className="dropdown-menu" role="menu">
          <button
            type="button"
            onClick={() => {
              onManageProducts();
              onClose();
            }}
          >
            <span className="menu-item-icon"><FontAwesomeIcon icon={faBoxOpen} /></span>
            <span>{t('menus.products')}</span>
          </button>
          <button
            type="button"
            onClick={() => {
              onManageProductCategories();
              onClose();
            }}
          >
            <span className="menu-item-icon"><FontAwesomeIcon icon={faTags} /></span>
            <span>{t('menus.productCategories')}</span>
          </button>
          <button
            type="button"
            onClick={() => {
              onManageUsers();
              onClose();
            }}
          >
            <span className="menu-item-icon"><FontAwesomeIcon icon={faUsersGear} /></span>
            <span>{t('menus.manageUsers')}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default AppMenu;
